import { render, staticRenderFns } from "./DeliveryAddressFormPop.vue?vue&type=template&id=03202a80&"
import script from "./DeliveryAddressFormPop.vue?vue&type=script&lang=ts&"
export * from "./DeliveryAddressFormPop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports